require("script-loader!../../lib/jquery/dist/jquery.js")
require("script-loader!../../lib/popper.js/popper.min.js")
require("script-loader!../../lib/bootstrap/dist/js/bootstrap.js")
require("script-loader!../../app/theme/lib/material/js/material.js")
require("script-loader!../../lib/knockout/build/output/knockout-latest.js")
require("script-loader!../../lib/knockout-validation/knockout.validation.js")

import bh = require("./Atlas/bindingHandlers");
import ex = require("./Atlas/Extenders");

import { hideSnackbar, enablePopovers, enableModalFocusTrap, setMenuFocus, addKeyboardHandlerForButtons, enableTooltips } from './Atlas/Controls'

const key = "app.ts_initialized";

$(document).ready(() => {
    // Recalculate widget area to area visible
    function widgetheight() {
        $("#widgetarea").css({
            "max-height": $(window).height() - 40
        });
        //$("#widgetarea").getNiceScroll().resize();
    }
    if (!$(document).data(key)) {
        $(document).data(key, true);

        //alert('hello world app.ts.');
        $("#globalSnackbarBtn").on("click", () => hideSnackbar());
        enablePopovers();
        bh.BindingHandlerRegistration.register();
        ex.ExtenderRegistration.register();

        enableModalFocusTrap(); //bootstrap is supposed to do this but is not
        setMenuFocus();
        addKeyboardHandlerForButtons();

        // On click of right menu
        $("#trigger-sidebar").click(function () {
            $("body").toggleClass("show-sidebar");
            widgetheight();


            var sidebarShown = $("body").hasClass("show-sidebar");
            console.log("firing sidebarToggle event");
            $("body").trigger("sidebarToggle", { sidebarShown: sidebarShown });
        });

        //Closing sidebar
        $("#dismissSidebar").on("click", function () {
            $("#trigger-sidebar").trigger("click"); //reuse the logic from clicking on the sidebar toggle button
            document.getElementById("trigger-sidebar").focus(); //set focus to the sidebar toggle button
        });
    }

    $(".table-responsive").on("shown.bs.dropdown", function (e) {
        let table = $(this);
        let menu = $(e.target).find(".dropdown-menu");
        let th = table.height();
        let mh = menu.outerHeight(true) + 30;

        if (mh > th)
            table.css("padding-bottom", mh - th);
    });

    $(".table-responsive").on("hide.bs.dropdown", function () {
        $(this).css("padding-bottom", 0);
    });
    enableTooltips();

});
